import { render, staticRenderFns } from "./WeeklyDueTasksTable.vue?vue&type=template&id=5308f66a&"
import script from "./WeeklyDueTasksTable.vue?vue&type=script&lang=js&"
export * from "./WeeklyDueTasksTable.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyDueTasksTable.vue?vue&type=style&index=0&id=5308f66a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports